module.exports = __webpack_public_path__ + "static/img/1.655b6b52.jpg";